module.exports = __webpack_public_path__ + "img/input_12.f88933e4.png";